import React from 'react';
import { cn } from '@/shared/lib/utils';
import { DraftBadge } from '@/shared/ui/DraftBadge';

type DraftIndicatorProps = {
  hasChanges: boolean;
  className?: string;
  message?: string;
  badgeLabel?: string;
};

export const DraftIndicator: React.FC<DraftIndicatorProps> = ({
  hasChanges,
  className,
  message = 'Des modifications ont été apportées au formulaire',
  badgeLabel = 'Non sauvegardé',
}) => {
  if (!hasChanges) return null;

  return (
    <div
      className={cn(
        'p-3 bg-orange-50 border border-orange-200 rounded-lg',
        className
      )}
    >
      <div className='flex flex-col items-start gap-2'>
        <DraftBadge hasChanges={true} label={badgeLabel} />
        <span className='text-sm text-orange-700'>{message}</span>
      </div>
    </div>
  );
};
